import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Box,
  Grid
} from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const faqData = [
  {
    question: "WHAT IS INCLUDED WITH WEBSITE",
    answer: "Web Hosting – Free for 1 Year SSL Certificate – Free for 1 Year Professional Business Email – Free for 1 Year"
  },
  {
    question: "DO YOU PROVIDE DOAMIN?",
    answer: "Yes we do provide domain as well but for that You need to pay the charge of the domain."
  },
  {
    question: "HOW TO MANAGE MY WEBSITE?",
    answer: "We provide free video guide in hindi and english Language in a very easy step by step process that will help you to add , edit and manage your website like pro without any problem."
  },
  {
    question: "WHAT IF I HAVE ANY ISSUE WITH MY WEBSITE IN FUTURE?",
    answer: "As we have said before our Dedicated support system is always free 24/7 for all customers so you can reach us any time via E-mail and WhatsApp Live chat.)"
  },
  {
    question: "HOW TO JOIN RESELLER?",
    answer: "You need to buy any of our Reselling membership plan which is listed on our site in order to become a Reseller."
  },
  {
    question: "I AM A NEWBE OR NON-TECHNICAL PERSON CAN I RESELL?",
    answer: "Any one can join us as a reseller because you have to do nothing with technology or experience we do everything for your client. You just focus on sales rest will be taken care of by us."
  }
];

function FAQ() {
  const [expanded, setExpanded] = useState('panel0');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  // Divide the FAQs into two equal parts
  const leftFaqs = faqData.slice(0, 3);
  const rightFaqs = faqData.slice(3);

  return (
    <Box sx={{ bgcolor: '#F5F5F5', minHeight: '80vh', py: 8 }} id="faq">
      <Container>
        <Typography
          variant="h3"
          component="h2"
          align="center"
          gutterBottom
          sx={{
            mb: 6,
            fontWeight: 'bold',
            color: '#1a237e'
          }}
        >
          Frequently Asked Questions
        </Typography>
        <Grid container spacing={4}>
          {/* Left Grid */}
          <Grid item xs={12} md={6}>
            {leftFaqs.map((faq, index) => (
              <Accordion
                key={index}
                expanded={expanded === `panel${index}`}
                onChange={handleChange(`panel${index}`)}
                sx={{
                  mb: 2,
                  '&:before': {
                    display: 'none',
                  },
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                  borderRadius: '8px !important',
                  overflow: 'hidden',
                  '&:first-of-type': {
                    borderRadius: '8px !important',
                  },
                  '&:last-of-type': {
                    borderRadius: '8px !important',
                  },
                  '&.Mui-expanded': {
                    margin: '0 0 16px 0',
                  }
                }}
              >
                <AccordionSummary
                  expandIcon={
                    expanded === `panel${index}` ? (
                      <RemoveCircleIcon size={24} />
                    ) : (
                      <AddCircleIcon size={24} />
                    )
                  }
                  sx={{
                    backgroundColor: expanded === `panel${index}` ? '#F3F4F6' : 'white',
                    '&:hover': {
                      backgroundColor: '#F3F4F6',
                    },
                    '& .MuiAccordionSummary-content': {
                      margin: '16px 0',
                    }
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '1.1rem',
                      fontWeight: 500,
                      color: '#1a237e'
                    }}
                  >
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    backgroundColor: 'white',
                    padding: '16px 24px 24px'
                  }}
                >
                  <Typography
                    sx={{
                      color: '#424242',
                      lineHeight: 1.7
                    }}
                  >
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>

          {/* Right Grid */}
          <Grid item xs={12} md={6}>
            {rightFaqs.map((faq, index) => (
              <Accordion
                key={index + 3} // Adjust the index to avoid duplication
                expanded={expanded === `panel${index + 3}`}
                onChange={handleChange(`panel${index + 3}`)}
                sx={{
                  mb: 2,
                  '&:before': {
                    display: 'none',
                  },
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                  borderRadius: '8px !important',
                  overflow: 'hidden',
                  '&:first-of-type': {
                    borderRadius: '8px !important',
                  },
                  '&:last-of-type': {
                    borderRadius: '8px !important',
                  },
                  '&.Mui-expanded': {
                    margin: '0 0 16px 0',
                  }
                }}
              >
                <AccordionSummary
                  expandIcon={
                    expanded === `panel${index + 3}` ? (
                      <RemoveCircleIcon size={24} />
                    ) : (
                      <AddCircleIcon size={24} />
                    )
                  }
                  sx={{
                    backgroundColor: expanded === `panel${index + 3}` ? '#F3F4F6' : 'white',
                    '&:hover': {
                      backgroundColor: '#F3F4F6',
                    },
                    '& .MuiAccordionSummary-content': {
                      margin: '16px 0',
                    }
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '1.1rem',
                      fontWeight: 500,
                      color: '#1a237e'
                    }}
                  >
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    backgroundColor: 'white',
                    padding: '16px 24px 24px'
                  }}
                >
                  <Typography
                    sx={{
                      color: '#424242',
                      lineHeight: 1.7
                    }}
                  >
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default FAQ;
